import { render, staticRenderFns } from "./CurrentAreaInfo.vue?vue&type=template&id=049c1f0c&"
import script from "./CurrentAreaInfo.vue?vue&type=script&lang=js&"
export * from "./CurrentAreaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports